import { graphql } from 'src/graphql';

import {
  TaskBlock,
  TaskBlockMatrix,
  TaskBlockSystemUsabilityScale,
  TaskBlockMultipleChoiceQuestion,
  TaskBlockOpenAnswer,
  TaskBlockOpinionScale,
  TaskBlockVariantComparison,
  TaskBlockStackRank,
} from 'containers/Studies/data/fragments/UnmoderatedTaskBlock.fragment';

export const CreateSurveyBooking = graphql(
  `
    mutation createSurveyBooking($input: CreateSurveyBookingInput!) {
      createSurveyBooking(input: $input) {
        _id
        name
        type
        status
        config {
          survey {
            welcome_block {
              type
              title
              instructions
            }
            thank_you_block {
              type
              title
              instructions
            }
            task_blocks {
              ...TaskBlock
              ...TaskBlockMatrix
              ...TaskBlockSystemUsabilityScale
              ...TaskBlockMultipleChoiceQuestion
              ...TaskBlockOpenAnswer
              ...TaskBlockOpinionScale
              ...TaskBlockStackRank
              ...TaskBlockVariantComparison
            }
          }
        }
      }
    }
  `,
  [
    TaskBlock,
    TaskBlockMatrix,
    TaskBlockSystemUsabilityScale,
    TaskBlockMultipleChoiceQuestion,
    TaskBlockOpenAnswer,
    TaskBlockOpinionScale,
    TaskBlockStackRank,
    TaskBlockVariantComparison,
  ],
);
